/**
 * Validates a node name according to specified rules.
 * Valid node names can only contain letters, digits, hyphens, underscores, and fullstops.
 * 
 * @param {string} name - The node name to validate
 * @returns {Object} - Object containing isValid flag and error message if invalid
 */
export const validateNodeName = (name) => {
  // Regular expression to match only allowed characters
  // Allows letters, digits, hyphens, underscores, and fullstops
  const validNameRegex = /^[a-zA-Z0-9\-_.]+$/;
  
  if (!name || name.trim() === '') {
    return {
      isValid: false,
      errorMessage: 'Name is required'
    };
  }
  
  if (!validNameRegex.test(name)) {
    return {
      isValid: false,
      errorMessage: 'Name must contain only letters, digits, hyphens, underscores and/or fullstops'
    };
  }
  
  return {
    isValid: true,
    errorMessage: ''
  };
};